module.exports = __webpack_public_path__ + "img/user-pic.dde1953c.svg";